import { API_BASE_URL } from "shared/api/config";
type BusinessType = "PICSHOT" | "PICO_KIDS";
type PaymentType = "CASH" | "ACCOUNT" | "QPAY";

export type Expense = {
  _id: string;
  businessType: BusinessType;
  expenseCategory: string;
  amount: number;
  paymentType: PaymentType;
  date: string; // YYYY-MM-DD
  description?: string;
  supplier?: string;
  createdAt: string;
};

const API_URL = `${API_BASE_URL}`; // өөрийн backend порт

export async function apiGetExpenses(params: {
  businessType?: string;
  date?: string;
  category?: string; // ✅ ADD
}) {
  const qs = new URLSearchParams();

  if (params.businessType) qs.set("businessType", params.businessType);
  if (params.date) qs.set("date", params.date);
  if (params.category) qs.set("category", params.category); // ✅ ADD

  const res = await fetch(`${API_URL}/expense?${qs.toString()}`);
  const data = await res.json().catch(() => ({}));

  if (!res.ok || data?.ok === false) {
    throw new Error(data?.message || `HTTP ${res.status}`);
  }

  // backend {ok:true, items:[...]} эсвэл шууд [...] аль алинд нь
  return (data.items ?? data) as Expense[];
}

export async function apiUpdateExpense(id: string, patch: Partial<Omit<Expense, "_id" | "createdAt">>) {
  const res = await fetch(`${API_URL}/expense/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  const data = await res.json();
  if (!res.ok || data?.ok === false) throw new Error(data?.message || "Update error");
  return data.expense as Expense;
}

export async function apiDeleteExpense(id: string) {
  const res = await fetch(`${API_URL}/expense/${id}`, { method: "DELETE" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data?.ok === false) throw new Error(data?.message || "Delete error");
  return true;
}



